import React, {useEffect, useState} from "react";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import BlogImagePopper from "./BlogImageLarge";
import image19 from "../../../../assets/images/Blog60/image19.png";
import image37 from "../../../../assets/images/Blog60/image37.png";
import image50 from "../../../../assets/images/Blog60/image50.png";
import image14 from "../../../../assets/images/Blog60/image14.png";
import image11 from "../../../../assets/images/Blog60/image11.png";
import image86 from "../../../../assets/images/Blog60/image86.png";
import image99 from "../../../../assets/images/Blog60/image99.png";
import image144 from "../../../../assets/images/Blog60/image144.png";
import image27 from "../../../../assets/images/Blog60/image27.png";
import image29 from "../../../../assets/images/Blog60/image29.png";
import image43 from "../../../../assets/images/Blog60/image43.png";
import image120 from "../../../../assets/images/Blog60/image120.png";
import image20 from "../../../../assets/images/Blog60/image20.png";
import image122 from "../../../../assets/images/Blog60/image122.png";
import image40 from "../../../../assets/images/Blog60/image40.png";
import image41 from "../../../../assets/images/Blog60/image41.png";
import image34 from "../../../../assets/images/Blog60/image34.png";
import image149 from "../../../../assets/images/Blog60/image149.png";
import image121 from "../../../../assets/images/Blog60/image121.png";
import image113 from "../../../../assets/images/Blog60/image113.png";
import image125 from "../../../../assets/images/Blog60/image125.png";
const Blog60 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – March 16, 2026</h2>
      </div>
      <div className="blogContentnew">
        <p className="highlightedText">Energy Shock Intensifies, Markets Confront Stagflation Risks and Positioning Stress</p>
        <p>
          Markets enter the third week of March navigating an environment where geopolitical developments and energy markets have begun to dominate macro sensitivities. Price action across assets
          reflects markets adjusting to sudden volatility in commodities and rising energy prices.
        </p>
        <p>
          Beneath the surface, participation has become increasingly selective. Commodity volatility has surged from previously suppressed levels, while positioning across equities and macro assets
          suggests investors are reassessing risk exposure. The resulting price behaviour reflects markets reacting to the intersection of geopolitical developments, energy supply uncertainty, and
          renewed inflation sensitivity.
        </p>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: Energy Shock Meets Resilient Equity Structure</p>
              <p>
                Equity markets have absorbed significant geopolitical developments without a complete breakdown in structure. Despite volatile headlines surrounding the conflict involving Iran and
                potential disruptions to energy supply routes, the S&P 500 has held relatively steady. This behaviour suggests markets are absorbing geopolitical developments without a broader
                deterioration in price structure.
              </p>
              <p>
                The dominant driver behind recent market behaviour has been the extreme volatility in energy markets. Oil prices experienced dramatic swings during the week, briefly approaching $120
                per barrel before falling sharply below $80 and then stabilising near $95 as traders reassessed the likelihood and duration of supply disruption.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image19}
                    alt="image19 crazy oil volatility"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image19)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                The sharp moves in crude followed escalating concerns around potential disruptions to shipping through the Strait of Hormuz, a critical global energy chokepoint through which a
                significant share of global oil supply transits.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image37}
                    alt="image37 SoH details"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image37)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>These developments have increased the geopolitical risk premium embedded in energy markets and amplified macro sensitivity across asset classes.</p>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Macro & Policy Watch: Energy Shock and Stagflation Concerns</p>
              <p>The current environment is defined by a central tension: an oil shock that simultaneously threatens economic growth while reigniting inflation pressures.</p>
              <p>
                Rising energy prices tighten financial conditions and increase production costs across regions dependent on imported energy. At the same time, weaker growth signals have emerged in
                several major economies, raising concerns that the global economy could face a stagflationary combination of slowing growth and persistent price pressures.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image50}
                    alt="image50 obvious CPI threat from oil"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image50)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                The geopolitical developments surrounding Iran have also heightened concerns about the stability of global energy transport routes. Markets are closely monitoring activity around the
                Strait of Hormuz as an indicator of potential disruption to global oil flows.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image14}
                    alt="image14 keep watching SoH traffic for oil price direction"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image14)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                Discussions around coordinated strategic oil reserve releases have emerged, highlighting the scale of the potential supply shock and the effort to prevent disruptions from escalating
                into a broader energy crisis.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image11}
                    alt="image11 IEA huge release 400m barrels"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image11)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>Even with these interventions, markets remain highly sensitive to developments surrounding energy supply and geopolitical tensions.</p>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Breakdown: Supportive, but Increasingly Fragile</p>
              <p>While equity indices remain structurally supported, several indicators suggest the underlying environment may be becoming more fragile.</p>
              <p>Market internals indicate participation has become increasingly selective. This type of structure often reflects cautious investor behaviour rather than broad conviction.</p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image86}
                    alt="image86 SPX internals"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image86)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                Positioning dynamics also suggest markets may be approaching an inflexion point. Systematic trading strategies such as CTAs appear to be nearing levels where trend shifts could trigger
                meaningful changes in flows.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image99}
                    alt="image99 CTAs at a crossroads"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image99)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                Sentiment indicators further reinforce the cautious tone. Measures of investor sentiment have moved into extreme fear territory, highlighting the degree of uncertainty surrounding
                geopolitical developments and energy markets.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image144}
                    alt="image144 Fear & Greed still extreme fear"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image144)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                Commodity markets also display signs of structural stress. Oil futures have moved into pronounced backwardation, indicating tight near-term supply conditions relative to longer-dated
                expectations.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image27}
                    alt="image27 oil 1m/6m backwardation"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image27)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                Options markets reinforce this signal. Even during temporary price declines, traders maintained demand for upside protection, suggesting persistent concern about further supply
                disruptions.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image29}
                    alt="image29 1m skew reflects geopolitical uncertainty"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image29)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week’s Recap: Energy Shock and Global Market Volatility</p>
              <p>
                Recent market developments were dominated by geopolitical escalation and the resulting volatility in global energy markets. Rapid shifts in oil prices, geopolitical headlines, and
                macro data releases created heightened uncertainty across asset classes.
              </p>
              <p className="highlightedText">Key Highlights:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span>
                    <br />
                    Economic data delivered mixed signals regarding global growth momentum. Growth indicators softened, while inflation risks increased amid higher energy prices.
                  </p>
                  <div
                    className="imageWrapperCont"
                    style={{marginTop: "22px"}}
                  >
                    <div className="relatedImg">
                      <img
                        src={image43}
                        alt="image43 US GDP miss"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image43)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt="zoom"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span>
                    <br />
                    Global investor participation continued to influence flows in several asset classes, reflecting the role of international positioning dynamics in shaping market behaviour.
                  </p>
                  <div
                    className="imageWrapperCont"
                    style={{marginTop: "22px"}}
                  >
                    <div className="relatedImg">
                      <img
                        src={image120}
                        alt="image120 Chinese investors piling in"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image120)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt="zoom"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings:</span>
                    <br />
                    Corporate developments remained secondary to geopolitical and energy market developments during the week.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Commodities:</span>
                    <br />
                    Commodity markets became the focal point for global investors as geopolitical developments triggered extreme volatility across energy markets.
                  </p>
                  <div
                    className="imageWrapperCont"
                    style={{marginTop: "22px"}}
                  >
                    <div className="relatedImg">
                      <img
                        src={image20}
                        alt="image20 OVX oil volatility index"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image20)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt="zoom"
                          />
                        </button>
                      </div>
                    </div>
                    <div className="relatedImg">
                      <img
                        src={image122}
                        alt="image122 real assets looking attractive still"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image122)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt="zoom"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto: </span>
                    <br />
                    Digital asset markets experienced volatility alongside broader market movements during the week. Price action continued to evolve around key technical levels as market participants
                    monitored positioning and supply dynamics.
                  </p>
                  <div
                    className="imageWrapperCont"
                    style={{marginTop: "22px"}}
                  >
                    <div className="relatedImg">
                      <img
                        src={image40}
                        alt="image40 Bitcoin back v Gold?"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image40)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt="zoom"
                          />
                        </button>
                      </div>
                    </div>
                    <div className="relatedImg">
                      <img
                        src={image41}
                        alt="image41 BTC nears 20m in issue"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image41)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt="zoom"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Oil:</span>
                    <br />
                    Crude markets remained the central driver of global market volatility as traders reacted to developments surrounding the Strait of Hormuz and potential disruptions to global
                    supply.
                  </p>
                  <div
                    className="imageWrapperCont"
                    style={{marginTop: "22px"}}
                  >
                    <div className="relatedImg">
                      <img
                        src={image34}
                        alt="image34 SoH closure impacts over time"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image34)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt="zoom"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead: Key Data and Market-Moving Signals</p>
              <p>
                The week is centred on geopolitical developments and energy market sensitivity, with oil headlines and access through the Strait of Hormuz remaining a key focus. Markets will also
                navigate a dense calendar of central bank decisions, including the RBA, Federal Reserve, Bank of Canada, Bank of Japan, SNB, BoE and ECB. Key inflation signals will come from U.S. PPI,
                Canadian CPI and eurozone CPI, while housing activity, employment indicators and regional surveys may provide additional insight into economic momentum.
              </p>

              <p className="highlightedText">Monday, March 16</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span> Industrial Production, Retail Sales, Fixed Asset Investment, Unemployment Rate
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span> House Prices and Foreign Direct Investment
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Canada:</span> CPI (MoM, YoY), Core CPI and Housing Starts
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Empire State Manufacturing Index
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Industrial Production and Manufacturing Production
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Capacity Utilisation Rate
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> NAHB Housing Market Index
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Tuesday, March 17</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Australia:</span> RBA Interest Rate Decision and Policy Statement
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Eurozone:</span> ZEW Economic Sentiment
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Germany:</span> ZEW Current Conditions
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> ADP Employment Change
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Pending Home Sales and Pending Home Sales Index
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> API Weekly Crude Oil Stocks
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Japan:</span> Trade Balance, Exports and Imports
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Wednesday, March 18</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Eurozone:</span> CPI (MoM, YoY) and Core CPI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> PPI (MoM, YoY) and Core PPI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Canada:</span> Bank of Canada Interest Rate Decision and Press Conference
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Federal Reserve Interest Rate Decision and Economic Projections
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Factory Orders
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Crude Oil Inventories
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Brazil:</span> Interest Rate Decision
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">New Zealand:</span> GDP
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Thursday, March 19</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Australia:</span> Employment Change and Unemployment Rate
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Japan:</span> Bank of Japan Interest Rate Decision
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Switzerland:</span> SNB Interest Rate Decision
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">UK:</span> Bank of England Interest Rate Decision
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Eurozone:</span> ECB Interest Rate Decision
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Initial Jobless Claims
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Philadelphia Fed Manufacturing Survey
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Building Permits and New Home Sales
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Friday, March 20</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span> Loan Prime Rate
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Russia:</span> Interest Rate Decision
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Germany:</span> PPI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Eurozone:</span> Trade Balance and Current Account
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Canada:</span> Retail Sales
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Canada:</span> IPPI and RMPI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">UK:</span> CBI Industrial Trends Orders
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Spain:</span> Consumer Confidence
                  </p>
                </li>
              </ul>

              <div
                className="imageWrapperCont"
                style={{marginTop: "22px"}}
              >
                <div className="relatedImg">
                  <img
                    src={image149}
                    alt="image149 EW160326"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image149)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: Energy Volatility Shapes Market Psychology</p>
              <p>Energy markets have become a central influence on current market behaviour, introducing renewed sensitivity around inflation, policy expectations, and geopolitical developments.</p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Equities:</span>
                    <br />
                    Equity indices remain structurally resilient despite geopolitical escalation. However, narrowing participation and positioning stress suggest that developments in energy markets
                    may continue to influence short-term market direction. There are signs of extreme underweights, shorts in financials and extreme downside protection levels in futures and options
                    going into expiry week
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold & Silver:</span>
                    <br />
                    Precious metals have not yet displayed strong safe-haven behaviour during the current geopolitical episode, reflecting the influence of currency movements and interest rate
                    expectations.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto:</span>
                    <br />
                    Digital assets continue to trade alongside broader risk sentiment and liquidity dynamics rather than functioning as defensive assets during periods of geopolitical stress. Could be
                    some relative switching from gold.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro:</span>
                    <br />
                    Energy markets remain the central variable shaping global macro conditions. Oil volatility, geopolitical risk surrounding transport routes, and policy responses will likely
                    continue influencing inflation expectations and broader market behaviour. Lots of heavy upside speculation in options influencing here.
                  </p>
                </li>
              </ul>
              <p className="highlightedText">
                The current environment reflects a market adjusting to new macro drivers rather than experiencing structural deterioration. Positioning dynamics and geopolitical developments may
                continue to generate episodic volatility as markets navigate an uncertain energy landscape.
              </p>
              <div
                className="imageWrapperCont"
                style={{marginTop: "22px"}}
              >
                <div className="relatedImg">
                  <img
                    src={image121}
                    alt="image121 vols and skews by asset"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image121)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image113}
                    alt="image113 Stagflation back and basket surging"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image113)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>
              <div
                className="imageWrapperCont"
                style={{marginTop: "22px"}}
              >
                <div className="relatedImg">
                  <img
                    src={image125}
                    alt="image125 peak oil is kev"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image125)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1QA0ULPb3MG3YhHIkaEQterHNR1Pc-X3gl5WEZBrY3VU/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog60;
